import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { CommandEmpty } from "cmdk";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

export default forwardRef((props: any, ref: any): any => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index: any) => {
    const item = props.items[index];

    if (item) {
      props.command(item);
    }
  };

  const upHandler = () => {
    setSelectedIndex(
      (selectedIndex + props.items.length - 1) % props.items.length,
    );
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: any) => {
      if (event.key === "ArrowUp") {
        upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        downHandler();
        return true;
      }

      if (event.key === "Enter") {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <Command className="w-[150px]">
      <CommandList className="flex flex-col gap-1 relative bg-background border-2 border-r-2">
        {props.items.length ? (
          <CommandGroup>
            {props.items.map((item: any, index: number) => {
              return (
                <CommandItem
                  className={
                    index === selectedIndex
                      ? "flex items-center text-start p-2 bg-muted/80 text-foreground"
                      : "flex items-center text-start p-2 hover:bg-muted/40 text-foreground"
                  }
                  key={index}
                  onSelect={() => selectItem(index)}
                >
                  {typeof item === "string" ? item : item.label}
                </CommandItem>
              );
            })}
          </CommandGroup>
        ) : (
          <CommandEmpty className="item">No result</CommandEmpty>
        )}
      </CommandList>
    </Command>
  );
});
